import * as core from '../../../../../../../core'
import * as changeImpactDepartment from '../change-impact-department'

export const RESOURCE = {
  payload: {
    description: 'Planning Giving',
    enumId: core.dms.models.Enum.Id.from({
      partialId: changeImpactDepartment.RESOURCE.payload.partialId,
    }),
    id: 'Planning Giving',
    name: 'Planning Giving',
  },
  type: core.quiver.Resource.Type.DmsEnumEntry,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.DmsEnumEntry>
